"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    border-radius: ", "em;\n    background: ", ";\n    padding-top: 40px;\n"], ["\n    width: 100%;\n    height: 100%;\n    border-radius: ", "em;\n    background: ", ";\n    padding-top: 40px;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 40px;\n    position: absolute;\n    background: #f5f5f5b0;\n    display: table;\n    table-layout: fixed;\n    background: ", ";\n    cursor: move;\n"], ["\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 40px;\n    position: absolute;\n    background: #f5f5f5b0;\n    display: table;\n    table-layout: fixed;\n    background: ", ";\n    cursor: move;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n    padding: 0 ", "em;\n    display: table-cell;\n    vertical-align: middle;\n"], ["\n    padding: 0 ", "em;\n    display: table-cell;\n    vertical-align: middle;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n    text-align: right;\n    white-space: nowrap;\n    width: 60px;\n"], ["\n    text-align: right;\n    white-space: nowrap;\n    width: 60px;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n    font-size: ", "em;\n    color: ", ";\n    cursor: pointer;\n"], ["\n    font-size: ", "em;\n    color: ", ";\n    cursor: pointer;\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", "em;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"], ["\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", "em;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require("../index");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCustomScrollbars = require("react-custom-scrollbars");

var _row = require("./row");

var _row2 = _interopRequireDefault(_row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Panel = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.dashboard.panel.wrapper.radius;
}, function (props) {
    return props.theme.dashboard.panel.content.background;
});

var Header = _styledComponents2.default.div(_templateObject2, function (props) {
    return props.theme.dashboard.panel.bar.background;
});

var Content = (0, _styledComponents2.default)(_reactCustomScrollbars.Scrollbars)(_templateObject3);

var Left = _styledComponents2.default.div(_templateObject4, function (props) {
    return props.theme.dashboard.panel.bar.padding;
});

var Right = Left.extend(_templateObject5);

var HeaderIcon = _styledComponents2.default.a(_templateObject6, function (props) {
    return props.theme.dashboard.panel.bar.iconSize;
}, function (props) {
    return props.theme.dashboard.panel.bar.iconColor;
});

var Title = _styledComponents2.default.div(_templateObject7, function (props) {
    return props.theme.dashboard.panel.bar.titleColor;
}, function (props) {
    return props.theme.dashboard.panel.bar.fontWeight;
}, function (props) {
    return props.theme.dashboard.panel.bar.fontSize;
});

var DashboardPanel = function (_Component) {
    _inherits(DashboardPanel, _Component);

    function DashboardPanel() {
        _classCallCheck(this, DashboardPanel);

        return _possibleConstructorReturn(this, (DashboardPanel.__proto__ || Object.getPrototypeOf(DashboardPanel)).apply(this, arguments));
    }

    _createClass(DashboardPanel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                style = _props.style,
                panelKey = _props.panelKey,
                panelProps = _props.panelProps,
                panelTitle = _props.panelTitle,
                component = _props.component,
                configurable = _props.configurable,
                panels = _props.panels,
                configurePanel = _props.configurePanel,
                deletePanelConfirmation = _props.deletePanelConfirmation,
                showHeader = _props.showHeader,
                configureIcon = _props.configureIcon,
                deleteIcon = _props.deleteIcon,
                rest = _objectWithoutProperties(_props, ["style", "panelKey", "panelProps", "panelTitle", "component", "configurable", "panels", "configurePanel", "deletePanelConfirmation", "showHeader", "configureIcon", "deleteIcon"]);

            //Generate a panel obejct to simplify passing values


            var panel = {
                key: panelKey,
                props: panelProps,
                title: panelTitle,
                component: component,
                configurable: configurable
            };

            var NewPanelProps = Object.assign(style, panelProps);

            return _react2.default.createElement(
                Panel,
                _extends({ style: style }, rest),
                _react2.default.createElement(
                    Content,
                    null,
                    _react2.default.createElement(panels[component], NewPanelProps)
                ),
                showHeader && _react2.default.createElement(
                    Header,
                    { className: "dragHandle" },
                    _react2.default.createElement(
                        Left,
                        null,
                        panelTitle && _react2.default.createElement(
                            Title,
                            null,
                            panelTitle
                        )
                    ),
                    _react2.default.createElement(
                        Right,
                        null,
                        configurable && [_react2.default.createElement(
                            HeaderIcon,
                            {
                                onClick: configurePanel.bind(this, panel)
                            },
                            configureIcon
                        ), " "],
                        _react2.default.createElement(
                            HeaderIcon,
                            {
                                onClick: deletePanelConfirmation.bind(this, panel)
                            },
                            deleteIcon
                        )
                    )
                ),
                this.props.children
            );
        }
    }]);

    return DashboardPanel;
}(_react.Component);

DashboardPanel.propTypes = {
    /** A unique key for this panel, probably a UUID */
    panelkey: _propTypes2.default.string.isRequired,
    /** The props to be passed on to the component being rendered into the panel (e.g. configuration options) */
    panelProps: _propTypes2.default.object,
    /** A string to be used in the title of the panel */
    panelTitle: _propTypes2.default.string,

    /** A string matching one of the keys in the panels object, this is used to render the correct component in the panel */
    component: function component(props, propName, componentName, location, propFullName) {
        var componentProp = props[propName];
        if (!componentProp || typeof componentProp !== "string") {
            throw new Error("component prop must be an string. Received: " + (typeof componentProp === "undefined" ? "undefined" : _typeof(componentProp)));
        }
        if (!(componentProp in props.panels)) {
            throw new Error("The component prop must have a matching key in the panels object.  The component: " + componentProp + " isn't available");
        }
    },


    /** Used to know if the panel has configuration options or not */
    configurable: _propTypes2.default.bool,
    /** An object containing a linking between component names, and the components */
    panels: _propTypes2.default.object.isRequired,
    /** A callback that's called when the delete panel button is pressed */
    deletePanelConfirmation: _propTypes2.default.func,
    /** A callback that's called when the configure panel button is pressed */
    configurePanel: _propTypes2.default.func,
    /** Used to turn on or off the header bar */
    showHeader: _propTypes2.default.bool,
    configureIcon: _propTypes2.default.element,
    deleteIcon: _propTypes2.default.element
};
DashboardPanel.defaultProps = {
    style: {},
    panelProps: {},
    showHeader: true,
    configureIcon: _react2.default.createElement(_index.Icon, { name: "gear" }),
    deleteIcon: _react2.default.createElement(_index.Icon, { name: "close" })
};

exports.default = (0, _styledComponents.withTheme)(DashboardPanel);


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/DashboardPanel.js
// module id = 986
// module chunks = 95715928098905 168707334958949